import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    // Load from localStorage on init
    const saved = localStorage.getItem('cart');
    return saved ? JSON.parse(saved) : [];
  });
  const [showCart, setShowCart] = useState(false);
  const [discountApplied, setDiscountApplied] = useState(null);

  // Save to localStorage when cart changes
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (course) => {
    setCartItems((prev) => {
      const exists = prev.some((item) => item.slug === course.slug);
      if (!exists) {
        return [...prev, course];
      }
      return prev;
    });
    setShowCart(true);
  };

  const removeFromCart = (courseSlug) => {
    setCartItems((prev) => prev.filter((item) => item.slug !== courseSlug));
  };

  const clearCart = () => {
    setCartItems([]);
    setDiscountApplied(null);
    localStorage.removeItem('cart');
  };

  const isInCart = (courseSlug) => {
    return cartItems.some((item) => item.slug === courseSlug);
  };

  const cartCount = cartItems.length;

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        isInCart,
        cartCount,
        showCart,
        setShowCart,
        discountApplied,
        setDiscountApplied,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};
